module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('feedback-modal', {
    ref: "feedbackModal",
    staticClass: "dashboard-action-modal"
  }, [_c('div', {
    staticClass: "dashboard-action-modal__message"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('simple-button', {
    staticClass: "dashboard-action-modal__button",
    attrs: {
      "text": _vm.buttonText
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fde1ca18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/audienceHubDashboard/DashboardActionModal.vue
// module id = 2009
// module chunks = 0